import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SinglePackageFormComponent } from './components/single-package-form/single-package-form.component';
import { LetDirective } from '@ngrx/component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { SinglePackagingModalComponent } from './components/modals/single-packaging-modal/single-packaging-modal.component';
import { UiModule } from '@hazmatsuite-next/ui';
import { SinglePackagingItemComponent } from './components/packing-list/single-packaging-item/single-packaging-item.component';
import { CompositePackagingModalComponent } from './components/modals/composite-packaging-modal/composite-packaging-modal.component';
import { InnerPackagingItemEditorComponent } from './components/inner-packaging-item-editor/inner-packaging-item-editor.component';
import { InnerPackagingItemComponent } from './components/packing-list/inner-packaging-item/inner-packaging-item.component';
import { CompositePackagingItemComponent } from './components/packing-list/composite-packaging-item/composite-packaging-item.component';
import { OverpackModalComponent } from './components/modals/overpack-modal/overpack-modal.component';
import { OverPackagingItemComponent } from './components/packing-list/over-packaging-item/over-packaging-item.component';
import { CalculatedNamePipe } from './pipes/calculated-name/calculated-name.pipe';
import { SinglePackagingFilterPipe } from './pipes/single-packaging-filter/single-packaging-filter.pipe';
import { CompositePackagingFilterPipe } from './pipes/composite-packaging-filter/composite-packaging-filter.pipe';

@NgModule({
  declarations: [
    SinglePackageFormComponent,
    SinglePackagingModalComponent,
    SinglePackagingItemComponent,
    CompositePackagingModalComponent,
    InnerPackagingItemEditorComponent,
    InnerPackagingItemComponent,
    CompositePackagingItemComponent,
    OverpackModalComponent,
    OverPackagingItemComponent,
    CalculatedNamePipe,
    SinglePackagingFilterPipe,
    CompositePackagingFilterPipe,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    FormsModule,
    LetDirective,
    UiModule,
  ],
  exports: [
    SinglePackageFormComponent,
    SinglePackagingModalComponent,
    SinglePackagingItemComponent,
    CompositePackagingModalComponent,
    CompositePackagingItemComponent,
    InnerPackagingItemComponent,
    OverPackagingItemComponent,
    SinglePackagingFilterPipe,
    CompositePackagingFilterPipe,
  ],
})
export class EasydgdLibModule { }
